<template>
  <nav id="mobile-menu" class="sidebar-mobile-menu">
    <ul class="sidebar-mobile-menu__links">
      <NavMenuMobileItem v-for="(item, index) in menuItems" :item="item" :key="index" class-prefix="sidebar-mobile-menu"></NavMenuMobileItem>
      <li class="sidebar-mobile-menu__link-item">
        <a href="/logout/">
          <div class="sidebar-mobile-menu__link-icon sidebar-mobile-menu__signout"><i class="fa fa-sign-out-alt"></i></div>
          <p class="sidebar-mobile-menu__link">Sign out</p>
        </a>
      </li>
    </ul>
  </nav>
</template>

<script>
  import lodash from 'lodash';
  import { mapGetters } from 'vuex';
  import NavMenuMobileItem from './NavMenuMobileItem.vue';

  export default {
    name: 'NavMenuMobile',
    components: {
      NavMenuMobileItem,
    },
    computed: {
      ...mapGetters('main', ['menuItems']),
    },
  }
</script>
